import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=5c922764&scoped=true&"
import script from "./ProductListItem.vue?vue&type=script&lang=js&"
export * from "./ProductListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductListItem.vue?vue&type=style&index=1&id=5c922764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c922764",
  null
  
)

export default component.exports